export const ORDERS_HUB_FILTER_IDS = {
  orderType: 'orderType',
  status: 'status',
  tracingStatus: 'tracingStatus',
  supplier: 'supplier',
  buyer: 'buyer',
  vendor: 'vendor',
  receiver: 'receiver',
  supplierCountry: 'supplierCountry',
  internalResponsible: 'internalResponsible',
  tags: 'tags',
  seasons: 'seasons',
  brands: 'brands',
  styleCustomProperties: 'styleCustomProperties',
  styleCollections: 'styleCollections',
  styleType: 'styleType',
  orderNumber: 'orderNumber',
  orderDate: 'orderDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  agreedDeliveryDate: 'agreedDeliveryDate',
  handoverDate: 'handoverDate',
  actualDeliveryDate: 'actualDeliveryDate',
} as const;

export type OrdersHubFilterId =
  (typeof ORDERS_HUB_FILTER_IDS)[keyof typeof ORDERS_HUB_FILTER_IDS];

const LEGACY_DELIVERY_DATE_FILTER_ID = 'deliveryDate';

const DELIVERY_DATE_FILTER_BY_VARIANT: Record<string, OrdersHubFilterId> = {
  agreed: ORDERS_HUB_FILTER_IDS.agreedDeliveryDate,
  handover: ORDERS_HUB_FILTER_IDS.handoverDate,
  // pre-rename variant still carried by old saved views and bookmarks
  expected: ORDERS_HUB_FILTER_IDS.handoverDate,
  actual: ORDERS_HUB_FILTER_IDS.actualDeliveryDate,
};

/**
 * Old saved views and links carry one `deliveryDate` filter as
 * `[variant, from, to]`. Returns the filters with it moved onto the matching
 * per-column date filter, or `null` when there is nothing to migrate.
 */
export function migrateLegacyDeliveryDateFilter(
  filters: Record<string, string[]>,
): Record<string, string[]> | null {
  const legacy = filters[LEGACY_DELIVERY_DATE_FILTER_ID];
  if (legacy === undefined) return null;

  const { [LEGACY_DELIVERY_DATE_FILTER_ID]: _, ...rest } = filters;
  const [variant = '', from = '', to = ''] = legacy;
  const target = DELIVERY_DATE_FILTER_BY_VARIANT[variant];
  if (target && (from || to) && rest[target] === undefined) {
    rest[target] = [from, to];
  }
  return rest;
}
